/**
 * Module-scoped holder for the current session's customerIds.
 *
 * `hipaaMiddleware` is a plain Segment source middleware (not a React
 * component), so it cannot read the Redux store directly. A small React
 * component inside the store tree (see `HipaaCustomerIdSync` in
 * `OneTrustConsentProvider`) pushes the customerIds found across the session's
 * orders and eligibilities in here whenever they change, and the middleware
 * reads them back synchronously per event.
 *
 * A session can span more than one customer (e.g. several orders), so this is a
 * list — an event is HIPAA if ANY of these customers is a HIPAA customer.
 * Starts empty: before any order/eligibility/redeem data has loaded we do not
 * know the customer, and events fired in that window are intentionally treated
 * as non-HIPAA (full payload).
 */
let currentCustomerIds: string[] = [];

export const setHipaaCustomerIds = (customerIds: string[]): void => {
  currentCustomerIds = customerIds;
};

export const getHipaaCustomerIds = (): string[] => currentCustomerIds;
